/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Chip, Skeleton, Stack } from '@mui/material';
import { formatBRL } from './constants';
import { SEGMENT_ALL } from './segmentConstants';

const SegmentFilterChips = ({ options, value, loading, onChange }) => {
  if (loading) {
    return (
      <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap', gap: 1 }}>
        {[0, 1, 2, 3].map((i) => (
          <Skeleton key={i} variant="rounded" width={100} height={32} />
        ))}
      </Stack>
    );
  }

  const chips = [
    { key: SEGMENT_ALL, label: 'Todos', total: null },
    ...(options || []),
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1,
        maxHeight: { xs: 88, sm: 'none' },
        overflowY: { xs: 'auto', sm: 'visible' },
      }}
    >
      {chips.map((opt) => {
        const isActive = (value || SEGMENT_ALL) === (opt.key ?? opt.value);
        const label =
          opt.key === SEGMENT_ALL
            ? 'Todos'
            : opt.total != null && opt.total > 0
              ? `${opt.label} · ${formatBRL(opt.total)}`
              : opt.label;

        return (
          <Chip
            key={opt.key ?? opt.value ?? opt.label}
            label={label}
            clickable
            color={isActive ? 'primary' : 'default'}
            variant={isActive ? 'filled' : 'outlined'}
            onClick={() => onChange(opt.key ?? opt.value)}
            sx={{ fontWeight: isActive ? 600 : 400 }}
          />
        );
      })}
    </Box>
  );
};

SegmentFilterChips.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object),
  value: PropTypes.string,
  loading: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

SegmentFilterChips.defaultProps = {
  options: [],
  value: SEGMENT_ALL,
  loading: false,
};

export default SegmentFilterChips;
